<template>
    <div class="page-reset-password">
        <div class="container">
            <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'ตั้งรหัสผ่านใหม่ - ProbPlus', 
                'Reset Password - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'ตั้งรหัสผ่านใหม่เข้าสู่ระบบในการเข้าเว็บไซต์',
                'ตั้งรหัสผ่านใหม่เข้าสู่ระบบในการเข้าเว็บไซต์')" />
            <ContentLoader :isDisplay="!contentReady" />
            <template v-if="contentReady">
                <div class="global-box-content">
                    <h1>{{ $PPlusEngine.getDictionary($route.params.lang, 'ตั้งรหัสผ่านใหม่', 'Reset Password') }}</h1>
                    <div class="form">
                        <i class="pe-7s-tools decoration"></i>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'เจ้าของบัญชี', 'Account Owner') }}</label>
                                    <div class="input-icon">
                                        <i class="pe-7s-user"></i>
                                        <input type="text" class="form-control" maxlength="100" :value="fields.firstname + ' ' + fields.lastname" readonly />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'รหัสผ่านใหม่', 'New Password') }}</label>
                                    <div class="input-icon">
                                        <i class="pe-7s-door-lock"></i>
                                        <input type="password" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(resetPasswordValidate.newPassword.invalid)" v-model="resetPasswordForm.newPassword" />
                                    </div>
                                    <span class="error-message" v-if="resetPasswordValidate.newPassword.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดกรอกรหัสผ่านใหม่', 'Please input your new password') }}</span>
                                    <span class="error-message" v-if="resetPasswordValidate.newPassword.length">{{ $PPlusEngine.getDictionary($route.params.lang, 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร', 'Password requires at least 8 characters') }}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ยืนยันรหัสผ่าน', 'Confirm Password') }}</label>
                                    <div class="input-icon">
                                        <i class="pe-7s-door-lock"></i>
                                        <input type="password" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(resetPasswordValidate.confirmPassword.invalid)" v-model="resetPasswordForm.confirmPassword" />
                                    </div>
                                    <span class="error-message" v-if="resetPasswordValidate.confirmPassword.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดยืนยันรหัสผ่าน', 'Please confirm your password') }}</span>
                                    <span class="error-message" v-if="resetPasswordValidate.confirmPassword.match">{{ $PPlusEngine.getDictionary($route.params.lang, 'การยืนยันรหัสผ่านใหม่ไม่ตรงกัน', 'Confirm password does not match') }}</span>
                                </div>
                            </div>
                        </div>
                        <span class="error-message" v-if="resetPasswordValidate.form.invalid">{{ resetPasswordValidate.form.message }}</span>
                        <div class="action">
                            <button class="btn btn-main btn-lg" @click="submitResetPassword()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ตั้งรหัสผ่าน', 'Setup') }}</button>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ContentLoader from '@/weact/components/ContentLoader';
import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    components: { 
        ContentLoader 
    },
    data() {
        return {
            contentReady: false,
            fields: {},
            resetPasswordForm: this.initModelResetPassword(),
            resetPasswordValidate: this.initValidateResetPassword()
        }
    },
    created() {
        let page = this;
        let params = this.$route.params;

        setTimeout(function(){
            page.getContent(params);
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent(params) {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {
                resetToken: params.token,
                langCode: this.$route.params.lang
            };
            this.resetPasswordForm.resetToken = params.token;

            this.$WeHelper.postAPI(apiURL, '/api/user/get-reset-password', postData).then((response) => {
                if (response.data.success) {
                    this.fields = response.data;
                    this.contentReady = true;
                } else {
                    this.$router.push('/' + this.$route.params.lang + '/');
                }
            });
        },
        initModelResetPassword() {
            return { newPassword: '', resetToken: '', langCode: this.$route.params.lang };
        },
        initValidateResetPassword() {
            return {
                newPassword: { invalid: false, blank: false, length: false },
                confirmPassword: { invalid: false, blank: false, match: false },
                form: { invalid: false, message: '' }
            }
        },
        submitResetPassword() {
            this.resetPasswordValidate = this.initValidateResetPassword();

            if (!this.validateResetPasswordField()) {
                let loader = this.$WeHelper.modalLoad();
                let apiURL = this.$PPlusConfig.ApiURL;
                
                this.$WeHelper.postAPI(apiURL, '/api/user/submit-reset-password', this.resetPasswordForm).then((response) => {
                    loader.hide();
                    
                    if (response.data) {
                        if (response.data.success) {
                            let timerInterval;
                            let page = this;

                            this.$swal({
                                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'เปลี่ยนรหัสผ่านเสร็จแล้ว', 
                                        'เปลี่ยนรหัสผ่านเสร็จแล้ว'),
                                html: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'กำลังออกจากหน้านี้ในอีก <span>8</span> วินาที จากนั้นทำการเข้าสู่ระบบด้วยรหัสผ่านใหม่', 
                                        'กำลังออกจากหน้านี้ในอีก <span>8</span> วินาที จากนั้นทำการเข้าสู่ระบบด้วยรหัสผ่านใหม่'),
                                timer: 8000,
                                type: 'success',
                                confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'รับทราบ', 
                                        'รับทราบ'),
                                onBeforeOpen: () => {
                                    timerInterval = setInterval(() => {
                                        page.$swal.getContent().querySelector('span').textContent = Math.ceil(page.$swal.getTimerLeft() / 1000)
                                    }, 1000)
                                },
                                onClose: () => {
                                    clearInterval(timerInterval);
                                    
                                    this.$cookie.delete('token');
                                    this.$router.push('/' + this.$route.params.lang + '/');
                                }
                            });
                        }
                        else {
                            this.resetPasswordValidate.form.invalid = true;
                            this.resetPasswordValidate.form.message = response.data.message;
                        }
                    }
                    else {
                        this.alertSystemError();
                    }
                });
            }
        },
        validateResetPasswordField() {
            var isError = false;

            if (!this.resetPasswordForm.newPassword) {
                this.resetPasswordValidate.newPassword.invalid = true;
                this.resetPasswordValidate.newPassword.blank = true;
                isError = true;
            }
            if (this.resetPasswordForm.newPassword && this.resetPasswordForm.newPassword.length < 8) {
                this.resetPasswordValidate.newPassword.invalid = true;
                this.resetPasswordValidate.newPassword.length = true;
                isError = true;
            }
            if (!this.resetPasswordForm.confirmPassword) {
                this.resetPasswordValidate.confirmPassword.invalid = true;
                this.resetPasswordValidate.confirmPassword.blank = true;
                isError = true;
            }
            if (this.resetPasswordForm.confirmPassword && this.resetPasswordForm.newPassword != this.resetPasswordForm.confirmPassword) {
                this.resetPasswordValidate.confirmPassword.invalid = true;
                this.resetPasswordValidate.confirmPassword.match = true;
                isError = true;
            }

            return isError;
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-reset-password {
    padding: 40px 0;

    h1 {
        text-align: center;
        font-size: 32px;
        font-weight: 200;
        color: #999;
        padding-bottom: 30px;

        &:after {
            content: " ";
            display: block;
            margin: 15px auto 0;
            width: 100px;
            height: 1px;
            background: $mainColor;
        }
    }

    .form {
        max-width: 400px;
        margin: auto;
        padding: 30px;
        border: 1px dashed #ddd;

        .decoration {
            font-size: 100px;
            text-align: center;
            color: #ddd;
            display: block;
            margin-bottom: 30px;
        }

        label {
            font-size: 14px;
            color: #666;
        }

        .form-control[readonly] {
            background-color: #f5f5f5;
        }
    }

    .action {
        text-align: center;
        margin-top: 10px;
    }
}
</style>